import { render, staticRenderFns } from "./bibliotecas.vue?vue&type=template&id=676f374e&scoped=true"
import script from "./bibliotecas.vue?vue&type=script&lang=js"
export * from "./bibliotecas.vue?vue&type=script&lang=js"
import style0 from "./bibliotecas.vue?vue&type=style&index=0&id=676f374e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676f374e",
  null
  
)

export default component.exports